class Fidelizacion
{
	id = null;
    mail_alternativo = null;
    direccion = null;
    tipo_documento = null;
    numero_documento = null;
    unidad_id = null;
    codigo_postal_id = null;

    constructor(obj) {    
	    // IF AN OBJECT WAS PASSED THEN INITIALISE PROPERTIES FROM THAT OBJECT
        for (var prop in obj) this[prop] = obj[prop];

        this.direccion = this.direccion.replaceAll('<br>', ', ');
  	}
}

export default Fidelizacion;